"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterBySearch = exports.checkIfUserTagSelected = exports.checkIfTagSelected = exports.checkIfUserSelected = exports.getUsersInTag = void 0;
/**
 * Filters a list of users based on their association with a specified tag.
 *
 * @param tag - An object representing the tag to filter by. It includes:
 *   - `type`: The type of tag, either 'Group' or 'Department'.
 *   - `name`: The name of the tag.
 * @param userList - An array of `AppUser` objects to be filtered.
 * @returns An array of `AppUser` objects that are associated with the specified tag.
 */
const getUsersInTag = (tag, userList) => {
    return userList.filter((user) => {
        if (tag.type === 'Department') {
            return user.departmentTags.includes(tag.name);
        }
        return user.groupTags.includes(tag.name);
    });
};
exports.getUsersInTag = getUsersInTag;
const checkIfUserSelected = (userId, memberList) => {
    if (!memberList)
        return false;
    return memberList.some((itineraryUser) => {
        if (itineraryUser.type === 'User') {
            if (itineraryUser.option === userId) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    });
};
exports.checkIfUserSelected = checkIfUserSelected;
const checkIfTagSelected = (tagName, memberList, tagTypes) => {
    if (!memberList)
        return false;
    const orgUser = memberList.find((itineraryUser) => {
        if (tagTypes.includes(itineraryUser.type)) {
            if (itineraryUser.option === tagName) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    });
    if (orgUser) {
        return true;
    }
    else {
        return false;
    }
};
exports.checkIfTagSelected = checkIfTagSelected;
const checkIfUserTagSelected = (userId, memberList, allOrgUsers) => {
    if (!memberList)
        return false;
    const orgUser = allOrgUsers.find((itineraryUser) => {
        return itineraryUser.id === userId;
    });
    const departmetSelected = orgUser.departmentTags.some((tag) => {
        return (0, exports.checkIfTagSelected)(tag, memberList, ['Department']);
    });
    const groupSelected = orgUser.groupTags.some((tag) => {
        return (0, exports.checkIfTagSelected)(tag, memberList, ['Group']);
    });
    if (departmetSelected || groupSelected) {
        return true;
    }
    else {
        return false;
    }
};
exports.checkIfUserTagSelected = checkIfUserTagSelected;
const filterBySearch = (userList, query) => {
    const filteredList = userList.filter((user) => {
        return (user.firstName.toLowerCase().includes(query.toLowerCase()) ||
            user.lastName.toLowerCase().includes(query.toLowerCase()) ||
            [user.firstName, user.lastName]
                .join(' ')
                .toLowerCase()
                .includes(query.toLowerCase()) ||
            user.email.toLowerCase().includes(query.toLowerCase()));
    });
    return filteredList;
};
exports.filterBySearch = filterBySearch;
